import React, { Suspense, lazy } from "react";
import { Router, Route, Switch } from "react-router-dom";

import { Redirect } from "react-router-dom";
import history from "@sijal/common/src/config/history";
import Loading from "@sijal/common/src/components/Loading";

const Admin = lazy(() => import("../Admin/layouts/Admin"));
const Website = lazy(() => import("../Website/Website"));
const Logout = lazy(() => import("@sijal/common/src/config/Logout"));
const Login = lazy(() => import("../components/Auth/Login"));
const Register = lazy(() => import("../components/Auth/Register"));

const MainRoute = () => {
  return (
    <Router history={history}>
      <Suspense fallback={<Loading />}>
        <Switch>
          <Route path="/logout" name="Logout" component={Logout} />
          <Route path="/login" component={Login} />
          <Route path="/register" component={Register} />
          <Route path="/admin" component={Admin} name="Admin" />
          <Route path="/student" component={Website} name="Student" />
          <Redirect from="/" to="/login" />
        </Switch>
      </Suspense>
    </Router>
  );
};

export default MainRoute;
